<div class="flex flex-col w-full h-full">

    <!-- ── Header ───────────────────────────────────────────────────────────── -->
    <div class="flex-shrink-0 flex items-center justify-between px-5 py-3 shadow bg-light-orange z-50">
        <h2 class="text-black font-extrabold text-lg uppercase tracking-widest">
            {{ title }}
        </h2>
        <button
            type="button"
            class="material-icons flex items-center custom-btn btn-dark-orange px-4 py-1"
            (click)="close()">
            close
        </button>
    </div>

    <!-- ── Scrollable Body ──────────────────────────────────────────────────── -->
    <div class="modal-body px-6 py-5">
        <div class="flex flex-col gap-4">

            <!-- Section Label Box -->
            <div class="section-label-box">
                <span class="orange-text font-extrabold uppercase text-sm">{{ sectionLabel }}</span>
            </div>

            <!-- Row 1: Load Provider | Network Provider | Item Type -->
            <div class="grid grid-cols-3 gap-3">

                <!-- Load Provider -->
                <div>
                    <app-custom-dropdown-v2
                        label="Load Provider:"
                        labelWidth="90px"
                        [options]="loadProviderOptions"
                        [selectedText]="provider_text || ''"
                        placeholder="== Select an Option =="
                        (selectionChange)="setProvider($event.label, $event.value)">
                    </app-custom-dropdown-v2>
                </div>

                <!-- Network Provider -->
                <div>
                    @if (isGamingPins && (!isEditMode || !originalIsGamingPins)) {
                        <div class="card-input flex items-center text-xs py-2 opacity-50 cursor-not-allowed">
                            <span class="text-xs font-semibold flex-shrink-0" style="width: 110px;">Network Provider:</span>
                            <input [readonly]="true" value="All"
                                class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic cursor-not-allowed"
                                type="text">
                        </div>
                    } @else if (isGamingPins && isEditMode && originalIsGamingPins) {
                        <app-dropdown-checklist-v2
                            label="Network Provider:"
                            labelWidth="110px"
                            [options]="networkProviderPinsOptions"
                            [placeholder]="providerType_text || '== Select an Option =='"
                            [selectedValues]="providerType || []"
                            [showDefaultOption]="true"
                            [defaultOptionLabel]="'All'"
                            (selectionChange)="setNetworkProvider($event)">
                        </app-dropdown-checklist-v2>
                    } @else {
                        <app-custom-dropdown-v2
                            label="Network Provider:"
                            labelWidth="110px"
                            [options]="networkProviderOptions"
                            [selectedText]="providerType_text || ''"
                            placeholder="== Select an Option =="
                            (selectionChange)="setProviderType($event.label, $event.value)">
                        </app-custom-dropdown-v2>
                    }
                </div>

                <!-- Item Type -->
                <div
                    [class.opacity-50]="(isEditMode && originalIsGamingPins) || isItemTypeLocked"
                    [class.cursor-not-allowed]="(isEditMode && originalIsGamingPins) || isItemTypeLocked"
                >
                    @if (isEditMode && originalIsGamingPins) {
                        <div class="card-input flex items-center text-xs py-2">
                            <span class="text-xs font-semibold flex-shrink-0" style="width: 70px;">Item Type:</span>
                            <input
                                [readonly]="true"
                                [value]="itemType_text"
                                class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic cursor-not-allowed"
                                type="text"
                            >
                        </div>
                    } @else if (isItemTypeLocked) {
                        <div
                            class="card-input flex items-center text-xs py-2"
                            [matTooltip]="itemTypeLockedTooltip"
                        >
                            <span class="text-xs font-semibold flex-shrink-0" style="width: 70px;">Item Type:</span>
                            <input
                                [readonly]="true"
                                [value]="itemType_text"
                                class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic cursor-not-allowed"
                                type="text"
                            >
                        </div>
                    } @else {
                        <app-custom-dropdown-v2
                            label="Item Type:"
                            labelWidth="70px"
                            [options]="itemTypeOptions"
                            [selectedText]="itemType_text || ''"
                            placeholder="== Select an Option =="
                            (selectionChange)="setItemType($event.label, $event.value)">
                        </app-custom-dropdown-v2>
                    }
                </div>

            </div>

            <!-- Row 2: Name | Item ID | Category + View List -->
            <div class="grid grid-cols-3 gap-3">

                <!-- Name -->
                <div
                    [appHighlightOnActive]="true"
                    class="card-input flex items-center text-xs py-2"
                >
                    <span class="text-xs font-semibold flex-shrink-0" style="width: 50px;">Name:</span>
                    <input
                        [formControl]="$any(form.get('itemName'))"
                        type="text"
                        placeholder="Name"
                        class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                    >
                </div>

                <!-- Item ID -->
                <div
                    [appHighlightOnActive]="true"
                    class="card-input flex items-center text-xs py-2"
                >
                    <span class="text-xs font-semibold flex-shrink-0" style="width: 55px;">Item ID:</span>
                    <input
                        [formControl]="$any(form.get('itemId'))"
                        type="text"
                        placeholder="Enter ID"
                        [class.cursor-not-allowed]="isEditMode"
                        [class.opacity-60]="isEditMode"
                        class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                    >
                </div>

                <!-- Category — manual trigger so VIEW LIST sits INSIDE the card-input -->
                <div
                    [class.opacity-50]="!isGamingPins"
                    [class.cursor-not-allowed]="!isGamingPins"
                    class="flex flex-col dropdown-host"
                    #categoryTrigger
                >
                    <div
                        class="card-input flex items-center text-xs py-2 dropdown-card"
                        [class.select-active]="categoryOpen"
                        (click)="isGamingPins && toggleCategoryDropdown()"
                        [class.cursor-pointer]="isGamingPins"
                    >
                        <span class="text-xs font-semibold flex-shrink-0" style="width: 60px;">Category:</span>

                        <!-- Selected text / placeholder -->
                        <span
                            class="barlow text-xs pl-1 italic truncate flex-1"
                            [class.placeholder-color]="!itemCategory_text"
                        >
                            {{ itemCategory_text || 'Enter Category' }}
                        </span>

                        <!-- VIEW LIST button — always visible, inside the card -->
                        <button
                            
                            [disabled]="!isGamingPins"
                            [class.btn-dark-orange]="isGamingPins"
                            [class.bg-gray-400]="!isGamingPins"
                            [class.cursor-not-allowed]="!isGamingPins"
                            class="uppercase custom-btn font-semibold text-xs px-3 flex-shrink-0 h-30-px flex items-center"
                            (click)="$event.stopPropagation(); openCategoryDialog()"
                        >
                            VIEW LIST
                        </button>
                    </div>

                    <!-- Inline dropdown panel -->
                    <div
                        *ngIf="categoryOpen && isGamingPins"
                        class="category-dropdown-panel mt-0.5"
                        [class.select-active]="categoryOpen"
                        role="listbox"
                    >
                        <div
                            *ngFor="let opt of categoryOptions"
                            class="dropdown-item tracking-wide italic text-xs"
                            [class.active]="opt.value === itemCategory"
                            (click)="selectCategory(opt)"
                            role="option"
                        >
                            {{ opt.label }}
                        </div>
                        <div
                            *ngIf="categoryOptions.length === 0"
                            class="dropdown-item italic text-gray-400"
                        >
                            No categories available
                        </div>
                    </div>
                </div>

            </div>

            <!-- Row 3: Price | Rebate Percentage | Sort -->
            <div class="grid grid-cols-3 gap-3">

                <div [appHighlightOnActive]="true" class="card-input flex items-center text-xs py-2">
                    <span class="text-xs font-semibold flex-shrink-0" style="width: 45px;">Price:</span>
                    <input
                        [formControl]="$any(form.get('itemPrice'))"
                        type="number"
                        placeholder="Price"
                        appOnlyNumber
                        [allowDecimal]="true"
                        class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                    >
                </div>

                <div [appHighlightOnActive]="true" class="card-input flex items-center text-xs py-2">
                    <span class="text-xs font-semibold flex-shrink-0" style="width: 150px;">Rebate Percentage (%):</span>
                    <input
                        [formControl]="$any(form.get('rebatePercentage'))"
                        type="number"
                        placeholder="Enter Percentage"
                        appOnlyNumber
                        [allowDecimal]="true"
                        class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                    >
                </div>

                <div [appHighlightOnActive]="true" class="card-input flex items-center text-xs py-2">
                    <span class="text-xs font-semibold flex-shrink-0" style="width: 35px;">Sort:</span>
                    <input
                        [formControl]="$any(form.get('sort'))"
                        type="number"
                        placeholder="Sort"
                        appOnlyNumber
                        class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                    >
                </div>

            </div>

            <!-- Row 4: Item Description -->
            <div [appHighlightOnActive]="true" class="card-input flex items-start text-xs py-2 w-full">
                <span class="text-xs font-semibold flex-shrink-0" style="width: 120px;">Item Description:</span>
                <textarea
                    [formControl]="$any(form.get('itemDesc'))"
                    placeholder="Enter Description"
                    class="placeholder-black focus:outline-none w-full bg-gray-100 rounded-md pl-3 resize-none italic"
                    style="height: 70px;"
                    rows="3"
                ></textarea>
            </div>

            <!-- ── REDEEM Section (edit mode only) ──────────────────────────── -->
            <ng-container *ngIf="isEditMode">

                <div class="section-label-box">
                    <span class="orange-text font-extrabold uppercase text-sm">REDEEM</span>
                </div>

                <div class="grid grid-cols-2 gap-3 px-20">

                    <div [appHighlightOnActive]="true" class="card-input flex flex-row items-center text-xs py-2 w-full rounded-md">
                        <span class="text-xs font-semibold text-gray-800">Redeemable?</span>
                        <div class="w-full flex justify-end gap-2 h-30-px">
                            <label class="flex items-center space-x-0.5 cursor-pointer">
                                <input
                                    class="radio-input"
                                    type="radio"
                                    [checked]="isRedeemable === true"
                                    (change)="setRedeemable(true)"
                                >
                                <span class="italic text-gray-700">Yes</span>
                            </label>
                            <label class="flex items-center space-x-0.5 cursor-pointer">
                                <input
                                    class="radio-input"
                                    type="radio"
                                    [checked]="isRedeemable === false"
                                    (change)="setRedeemable(false)"
                                >
                                <span class="italic text-gray-700">No</span>
                            </label>
                        </div>
                    </div>

                    <div class="card-input flex items-center text-xs py-2 w-full rounded-md px-3 cursor-not-allowed" style="border-color: gray;">
                        <span class="text-xs w-90-px font-semibold text-gray-600">Points:</span>
                        <div class="w-full flex items-center justify-center space-x-4 h-30-px">
                            <span
                                class="material-icons transform transition-transform duration-700 ease-in-out"
                                [ngClass]="isRedeemable ? 'orange-text' : 'text-gray-400'"
                                [style.transform]="isRedeemable ? 'rotate(215deg)' : 'rotate(0deg)'"
                            >
                                star
                            </span>
                            <span class="text-xs w-90-px font-semibold text-gray-600">
                                {{ form.get('pointsAmount')?.value | number:'1.2-2' | nullWithDefault }}
                            </span>
                        </div>
                    </div>

                </div>

            </ng-container>

            <!-- Submit -->
            <div class="flex items-center justify-center mt-2">
                <button
                    (click)="submit()"
                    appDisableWithoutPermission="megapay.skusBillers.buyLoad.edit"
                    matTooltip
                    class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-8 py-2"
                >
                    SUBMIT
                </button>
            </div>

        </div>
    </div>

</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>